import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bookingUrlPipe',
  standalone: false,
})
export class BookingUrlPipe implements PipeTransform {
  transform(url: string | null): string | null {
    if (!url) {
      return null;
    }

    if (!url.startsWith('http')) {
      return url;
    }

    // Attempt to use the URL constructor if available
    if (typeof URL !== 'undefined') {
      return new URL(url).pathname;
    }

    // Fallback to creating an anchor element for older browsers
    const anchorElement = document.createElement('a');
    anchorElement.href = url;

    return anchorElement.pathname; // Return the pathname from the created anchor
  }
}
